import React from 'react';
import { useTranslation } from 'react-i18next';
import EventList from '../components/home/EventList';

const Home = () => {
	const { t } = useTranslation();

	return (
		<div className='Page'>
	    	<h1>{t('home.title')}</h1>
			<EventList/>
		</div>
	);
};

export default Home;
